import React, {Suspense} from 'react';
import ReactDOM from 'react-dom';
import {GoogleOAuthProvider} from '@react-oauth/google';
import {HelmetProvider} from 'react-helmet-async';
import './index.css';
import App from './App';
import {Provider} from 'react-redux';
import store from './redux/store';

import * as serviceWorker from './serviceWorker';

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '415228483034-1ld0g8iknni4sm67ds65i7l7csi4jl95.apps.googleusercontent.com';

const rootEl = document.getElementById('root');
if (rootEl) {
	ReactDOM.render(
		<HelmetProvider prioritizeSeoTags>
			<GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
				<Provider store={store}>
					<Suspense fallback={<div>Loading....</div>}>
						<App />
					</Suspense>
				</Provider>
			</GoogleOAuthProvider>
		</HelmetProvider>,
		rootEl
	);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
